import {
  BaseTableRequest,
  CreatePartnerCodeRequest,
  PartnerCode,
  Response,
  TableResponse,
  UpdatePartnerCodeRequest,
  ValidatePartnerCodeResponse,
} from 'types'
import axiosInstance from './axios'

export const getPartnerCodes = async (
  request: BaseTableRequest,
): Promise<TableResponse<PartnerCode>> => {
  return axiosInstance.post('/partner-codes', request)
}

export const createPartnerCode = async (
  request: CreatePartnerCodeRequest,
): Promise<Response<PartnerCode>> => {
  return axiosInstance.post('/partner-codes/create', request)
}

export const updatePartnerCode = async (
  request: UpdatePartnerCodeRequest,
): Promise<Response<PartnerCode>> => {
  return axiosInstance.post('/partner-codes/update', request)
}

/**
 * Classifies a code entered during registration or subscription purchase. Works with and without a
 * token, and answers 200 for unknown, inactive and exhausted codes alike — callers route on
 * `outcome` instead of catching errors. The backend uppercases the code itself.
 */
export const validatePartnerCode = async (
  code: string,
): Promise<Response<ValidatePartnerCodeResponse>> => {
  return axiosInstance.post('/partner-codes/validate', { code: code.trim() })
}
